module.exports = __webpack_public_path__ + "img/1.daef9e77.jpg";